import { Ref, forwardRef } from 'react';
import { AsyncAutocompleteProps } from './asyncAutocomplete.types';
import AsyncAutocompleteView from './components/AsyncAutocompleteView';
import { useAsyncAutocomplete } from './hooks/useAsyncAutocomplete';

function AsyncAutocomplete<T, Multiple extends boolean | undefined = undefined>(
  {
    source,
    fetcher,
    value,
    onChange,
    getOptionLabel,
    renderOption,
    getOptionId,
    formatOptions,
    multiple,
    initialData,
    onOpen,
    onCreateOption,
    ...presentation
  }: AsyncAutocompleteProps<T, Multiple>,
  ref: Ref<HTMLInputElement>,
) {
  const bundle = useAsyncAutocomplete<T, Multiple>({
    source,
    fetcher,
    value,
    onChange,
    getOptionLabel,
    renderOption,
    getOptionId,
    formatOptions,
    multiple,
    initialData,
    onOpen,
    onCreateOption,
  });

  return <AsyncAutocompleteView<Multiple> ref={ref} {...bundle} {...presentation} />;
}

const ForwardedAsyncAutocomplete = forwardRef(AsyncAutocomplete);
ForwardedAsyncAutocomplete.displayName = 'AsyncAutocomplete';

export default ForwardedAsyncAutocomplete as <T, Multiple extends boolean | undefined = undefined>(
  props: AsyncAutocompleteProps<T, Multiple> & { ref?: Ref<HTMLInputElement> },
) => React.ReactElement;
